// Google Ads Conversion Tracking
// Google Ads Account: AW-17950808260

/**
 * IMPORTANT: After deploying, you need to create conversion actions in Google Ads
 * and replace the conversion labels below.
 * 
 * Steps:
 * 1. Go to Google Ads > Tools > Conversions
 * 2. Create "Purchase" conversion action
 * 3. Copy the conversion label (looks like: AbC123dEfGhI)
 * 4. Replace 'PURCHASE_LABEL' below with your actual label
 * 5. Repeat for Registration conversion
 */

/**
 * Track Premium Bundle Purchase
 * Call this when user successfully purchases Premium Bundle
 */
export const trackPurchase = (transactionId, value = 75) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-17950808260/T_0gCOWH0fsbEMSxzu9C',
      'value': value,
      'currency': 'AUD',
      'transaction_id': transactionId
    });
    console.log('Purchase conversion tracked:', transactionId, value);
  } else {
    console.warn('Google tag not loaded yet');
  }
};

/**
 * Track User Registration
 * Call this when user successfully creates an account
 */
export const trackRegistration = (userId) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-17950808260/HT1dCJ31m4QcEMSxzu9C',
      'user_id': userId
    });
    console.log('Registration conversion tracked:', userId);
  } else {
    console.warn('Google tag not loaded yet');
  }
};

/**
 * Track Test Started
 * Call this when user starts a practice test
 */
export const trackTestStarted = (testName, testType) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'begin_test', {
      'test_name': testName,
      'test_type': testType
    });
    console.log('Test started tracked:', testName);
  }
};

/**
 * Track Page View
 * Automatically tracked by gtag config, but can be called manually
 */
export const trackPageView = (pagePath) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      'page_path': pagePath
    });
  }
};
